import React, { useState, useEffect } from 'react';

function Question({ 
  question, 
  onAnswerSubmit, 
  questionNumber, 
  totalQuestions,
  isExplanationVisible,
  explanationTextToShow,
  onProceed 
}) {
  const [selectedOption, setSelectedOption] = useState(null);
  // isSubmitted is now effectively controlled by isExplanationVisible from App.js

  useEffect(() => {
    // Reset selection when question changes (and not just when explanation appears)
    setSelectedOption(null);
  }, [question]);

  const handleOptionSelect = (option) => {
    if (!isExplanationVisible) { // Only allow selection if explanation is not visible
      setSelectedOption(option);
    }
  };

  const handleSubmitOrProceed = () => {
    if (isExplanationVisible) {
      onProceed(); // Move to next question or finish
    } else {
      if (selectedOption) {
        // In Question.js, selectedOption.points represents if the answer is correct (1 or 0)
        // and question.comment is the explanation text.
        onAnswerSubmit(selectedOption.points, question.comment);
      } else {
        alert('Proszę wybrać odpowiedź.');
      }
    }
  };

  // Remove punctuation from question text as requested by user
  const formattedQuestionText = question.text.replace(/[?:!.,;]$/, '');

  return (
    <div className="min-h-screen flex flex-col items-center justify-center p-4 bg-white text-gray-800">
      <div className="bg-white shadow-xl rounded-xl p-8 max-w-2xl w-full border border-gray-200">
        <div className="mb-6 text-center">
            <p className="text-sm font-semibold text-digital-orange">Pytanie {questionNumber} z {totalQuestions}</p>
            <h2 className="text-2xl font-bold mt-2 text-gray-800">{formattedQuestionText}</h2>
        </div>
        
        <div className="space-y-4 mb-8">
          {question.options.map((option, index) => (
            <button
              key={index}
              onClick={() => handleOptionSelect(option)}
              disabled={isExplanationVisible}
              className={`w-full text-left p-4 rounded-lg border-2 transition-all duration-150 ease-in-out
                          ${isExplanationVisible
                            ? selectedOption === option // After explanation is visible
                              ? option.points > 0 
                                ? 'bg-green-500 border-green-600 text-white' // Selected by user & correct
                                : 'bg-red-500 border-red-600 text-white'   // Selected by user & incorrect
                              : option.points > 0 // Not selected by user, but is the correct answer
                                ? 'bg-white border-green-500 text-green-700' 
                                : 'bg-white border-gray-300 text-gray-700'   // Not selected by user & incorrect
                            : selectedOption === option // Before explanation is visible
                              ? 'bg-digital-orange border-digital-orange text-white shadow-lg' // Currently selected by user
                              : 'bg-white hover:bg-orange-50 border-gray-300 hover:border-digital-orange text-gray-700' // Available option, not selected
                          }
                          ${isExplanationVisible ? 'cursor-not-allowed' : 'hover:scale-102'}`}
            >
              <span className="font-medium">{option.text}</span>
              {/* <span className="text-xs"> ({option.points} pkt.)</span> */}
            </button>
          ))}
        </div>

        {isExplanationVisible && (
          <div className="mb-6 p-4 bg-orange-50 rounded-lg border border-orange-200 text-gray-700">
            <h3 className="font-bold text-lg mb-2 text-digital-orange">Wyjaśnienie:</h3>
            <p>{explanationTextToShow}</p>
          </div>
        )}

        <button
          onClick={handleSubmitOrProceed}
          disabled={!isExplanationVisible && !selectedOption} // Disabled if no option selected (before explanation)
          className="w-full btn btn-primary text-lg py-3 shadow-lg transform hover:scale-105 transition duration-150 disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {isExplanationVisible 
            ? (questionNumber === totalQuestions ? 'Zakończ Quiz' : 'Następne pytanie') 
            : 'Zatwierdź odpowiedź'}
        </button>
      </div>
    </div>
  );
}

export default Question; 